<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="header mt-md-5">
                    <div class="header-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="header-pretitle">{{$t('Company')}}</h6>
                                <h1 class="header-title">{{$t('Workplaces')}}</h1>
                            </div>
                            <div class="col-auto">
                                <button
                                    @click="openModal({id:'WorkPlaceModal'})"
                                    class="btn btn-primary"
                                >{{ $t('New workplace') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header">
                        <div class="row align-items-center">
                            <div class="col">
                                <!-- Search -->
                                <div class="row align-items-center">
                                    <div class="col-auto pr-0">
                                    </div>
                                    <div class="col">
                                    </div>
                                </div>
                            </div>

                            <div class="col-auto">
                            </div>
                            <div class="col-auto">
                            </div>
                        </div>
                    </div>
                    <simple-table
                        :columns="columns"
                        :loading="areWorkPlacesLoading"
                        :data="workPlaces"
                        :edit="openWorkPlaceModal"
                        :deleteItem="removeItem">
                    </simple-table>
                </div>
            </div>
        </div>
        <work-place-modal id="WorkPlaceModal"></work-place-modal>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapState} from 'vuex'
    import {modalMixins} from "@/mixins/modal";
    import WorkPlaceModal from "./WorkPlaceModal";
    import SimpleTable from "@/components/SimpleTable";

    export default {
        name: "WorkPlaces",
        components: {SimpleTable, WorkPlaceModal},
        mixins: [modalMixins],
        data() {
            return {
                columns: [
                    {
                        label: '',
                        name: 'status',
                        width: 1,
                        field: (item) => {
                            let result = '';
                            if (item.color)
                                result += `<h1 style="color: ${item.color}">●</h1>`;
                            if (item.public)
                                result += '<i class="fe fe-check" />';
                            return result;

                        }
                    },
                    {
                        label: 'Name',
                        name: 'label',
                        field: item => item.label
                    }
                ]
            }
        },
        mounted() {
            this.fetchWorkPlaces();
        },

        methods: {
            ...mapActions('work-place', {findWorkPlaces: 'find', removeWorkPlace: 'remove'}),

            fetchWorkPlaces() {
                let query = {};
                this.findWorkPlaces({query});
            },

            openWorkPlaceModal(item) {
                let workPlace = {
                    model: item,
                    _id: 'temp'
                };
                const {WorkPlace} = this.$FeathersVuex;
                new WorkPlace(workPlace);

                this.openModal({id: 'WorkPlaceModal'});
            },

            removeItem(item) {
                this.removeWorkPlace(item._id);
            }
        },

        computed: {
            ...mapGetters('work-place', {findWorkPlacesInStore: 'find'}),
            ...mapState('work-place', {areWorkPlacesLoading: 'isLoading'}),

            workPlaces() {
                return this.findWorkPlacesInStore({query: {_id: {$ne: 'temp'}}}).data;
            }
        }
    }
</script>

<style scoped>

</style>
